<template>
  <section class="page-stack">
    <div class="page-intro"><div><p class="eyebrow">MEMBERSHIP WORKFLOW</p><h2>申请与关系管理</h2><p>统一处理主播申请、入会、退会和转会流程。</p></div></div>
    <article class="panel">
      <div class="segment-tabs">
        <button v-for="item in types" :key="item.value" :class="{ active: requestType === item.value }" @click="switchType(item.value)">{{ item.label }}</button>
      </div>
      <div class="toolbar">
        <el-select v-model="status" @change="search"><el-option label="待处理" value="0" /><el-option label="已通过" value="1" /><el-option label="已拒绝" value="2" /><el-option label="全部状态" value="" /></el-select>
        <el-button icon="el-icon-refresh" @click="load">刷新</el-button>
      </div>
      <el-table v-loading="loading" :data="rows">
        <el-table-column prop="request_no" label="申请编号" width="190" />
        <el-table-column label="头像" width="76" align="center" class-name="request-avatar-column">
          <template slot-scope="{ row }"><el-avatar class="request-avatar" :size="40" :src="row.avatar_url">{{ avatarInitial(row) }}</el-avatar></template>
        </el-table-column>
        <el-table-column label="主播" min-width="210"><template slot-scope="{ row }"><div class="request-creator-copy"><strong>{{ row.name }}</strong><span>@{{ row.account }} · {{ row.email }}</span></div></template></el-table-column>
        <el-table-column label="业务类型" width="110"><template slot-scope="{ row }">{{ typeText(row.request_type) }}</template></el-table-column>
        <el-table-column prop="target_guild_name" label="目标公会" min-width="150"><template slot-scope="{ row }">{{ row.target_guild_name || "—" }}</template></el-table-column>
        <el-table-column prop="reason" label="申请说明" min-width="220" show-overflow-tooltip />
        <el-table-column label="主播礼物分成" width="130"><template slot-scope="{ row }">{{ liveGiftSharePercent(row) }}%</template></el-table-column>
        <el-table-column prop="create_time" label="提交时间（UTC）" width="175" />
        <el-table-column label="状态" width="100"><template slot-scope="{ row }"><span :class="['status-chip', statusClass(row.status)]">{{ statusText(row.status) }}</span></template></el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }"><template v-if="row.can_review"><el-button type="text" @click="review(row,1)">通过</el-button><el-button type="text" class="danger-text" @click="review(row,2)">拒绝</el-button></template><span v-else class="muted">—</span></template>
        </el-table-column>
      </el-table>
      <table-pager :total="count" :page="page" :limit="limit" @page-change="changePage" @limit-change="changeLimit" />
    </article>
  </section>
</template>
<script>
import { requestListGet, requestReview } from "../api/guild"
import TablePager from "../components/TablePager.vue"
export default {
  name: "RequestsView",
  components: { TablePager },
  data: () => ({ types: [{ value: "", label: "全部申请" }, { value: "invite", label: "邀请记录" }, { value: "join", label: "入会审核" }, { value: "exit", label: "退会管理" }, { value: "transfer", label: "转会管理" }], requestType: "", status: "0", rows: [], count: 0, page: 1, limit: 20, loading: false }),
  created() { this.load() },
  methods: {
    async load() { this.loading = true; try { const res = await requestListGet({ request_type: this.requestType, status: this.status, page: this.page, limit: this.limit }); this.rows = res.data.data; this.count = Number(res.data.count) } finally { this.loading = false } },
    search() { this.page = 1; this.load() },
    switchType(type) { this.requestType = type; this.search() },
    changePage(page) { this.page = page; this.load() },
    changeLimit(limit) { this.limit = limit; this.page = 1; this.load() },
    typeText(type) { return { invite: "公会邀请", join: "申请入会", exit: "申请退会", transfer: "申请转会" }[type] || type },
    statusText(value) { return { 0: "待处理", 1: "已通过", 2: "已拒绝", 3: "已取消" }[Number(value)] },
    statusClass(value) { return { 0: "warning", 1: "success", 2: "danger", 3: "neutral" }[Number(value)] },
    avatarInitial(row) { return row && row.name ? row.name.slice(0, 1) : "?" },
    liveGiftSharePercent(row) {
      const raw = row && row.live_gift_creator_share_bps
      const bps = raw === null || raw === undefined || raw === "" ? 5500 : Number(raw)
      return Number.isFinite(bps) ? bps / 100 : 55
    },
    review(row, status) {
      const action = status === 1 ? "通过" : "拒绝"
      this.$prompt(`${action}“${row.name}”的${this.typeText(row.request_type)}申请？`, `${action}申请`, { inputPlaceholder: "可填写处理说明", inputType: "textarea" })
        .then(async ({ value }) => { await requestReview({ id: row.id, status, review_note: value || "" }); this.$message.success("申请已处理"); this.load() }).catch(() => {})
    }
  }
}
</script>
